import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditConfigurations from './EditConfigurations'
import ListConfigurations from './ListConfigurations'
import NewConfigurations from './NewConfigurations'

const AdminConfigurationsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListConfigurations /></PrivateRoute7>} />
        <Route path="edit-configuration" element={<PrivateRoute7><EditConfigurations /></PrivateRoute7>} />
        <Route path="new-configuration" element={<PrivateRoute7><NewConfigurations /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminConfigurationsRoutes